import { useParams } from 'react-router-dom';
import { WebsiteDoorverwijzingen } from '@/features/website/Doorverwijzingen';
import { WebsiteInstellingen } from '@/features/website/Instellingen';
import { WebsiteMedia } from '@/features/website/Media';
import { WebsitePagina, WebsitePaginas } from '@/features/website/Paginas';
import { DOORVERWIJZINGEN_PAD, INSTELLINGEN_PAD, MEDIA_PAD, PAGINAS_PAD, WebsiteBewerk, WebsiteLijst, WebsiteOverzicht } from '@/features/website/WebsiteBeheer';

/* /crm/website/site: de content van greenvision.energy (ADR 0024). De schermen staan in
 * src/features/website. Niet te verwarren met /crm/website (planning: taken, ideeën, notities). */
export function CRMWebsiteSite() {
  return <WebsiteOverzicht />;
}

/* De vaste pagina's staan op /crm/website/site/paginas, de instellingen van de site op
 * /crm/website/site/instellingen, de doorverwijzingen op /crm/website/site/doorverwijzingen en de media
 * op /crm/website/site/media. Die adressen vallen onder de route met :soort in App.tsx. Die route blijft
 * zoals hij is (App.tsx valt onder de V1-lock); de keuze tussen de lijst van een soort, de pagina's, de
 * instellingen, de doorverwijzingen en de media staat daarom hier. */
export function CRMWebsiteSiteLijst() {
  const { soort } = useParams();
  if (soort === PAGINAS_PAD) return <WebsitePaginas />;
  if (soort === INSTELLINGEN_PAD) return <WebsiteInstellingen />;
  if (soort === DOORVERWIJZINGEN_PAD) return <WebsiteDoorverwijzingen />;
  if (soort === MEDIA_PAD) return <WebsiteMedia />;
  return <WebsiteLijst />;
}

/* Het formulier van één vaste pagina staat op /crm/website/site/paginas/:id, onder de route met
 * :soort/:id. Een pagina is geen soort content: hij heeft een eigen formulier. */
export function CRMWebsiteSiteBewerk() {
  const { soort } = useParams();
  if (soort === PAGINAS_PAD) return <WebsitePagina />;
  return <WebsiteBewerk />;
}

export default CRMWebsiteSite;
